export default function MainSlogan(props) {
    return (
        <p>
            {props.text}
        </p>
    );
}
